import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

export default function MiniWebSiteNotFoundPage() {
  return (
    <Grid
      container
      display="flex"
      sx={{
        background: 'linear-gradient(180deg, #FFFFFF 0%, #FFEEE7 100%)',
        minHeight: '100vh',
        padding: '16px',
        gap: '36px',
      }}
      alignItems="center"
      justifyContent="center"
      direction="column"
    >
      <Grid item>
        <img src="/assets/icons/not-found.svg" alt="not-found" />
      </Grid>
      <Typography variant="h4" color="primary" sx={{ textAlign: 'center' }}>
        404 - Page Not Found
      </Typography>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="body1" color="primary">
          What you can do:
        </Typography>
        <Typography variant="body2" color="primary">
          1. Check the URL: Ensure it&apos;s entered correctly.
        </Typography>
      </Box>
      <Typography variant="body2" color="primary" sx={{ textAlign: 'center', marginTop: '16px' }}>
        Thank you for your understanding.
      </Typography>
    </Grid>
  );
}
